import { addDays, formatDistanceStrict } from 'date-fns';
import { ru } from 'date-fns/locale';
import { PartnerClientManagerDictionary } from 'types/i18n';
import { sharedDictionaryRu } from './sharedDictionaryRu';

export const partnerClientManagerDictionaryRu: PartnerClientManagerDictionary = {
  summaryTabLabel: 'Информация',
  paymentsTabLabel: 'Платежи',
  clientSummaryTable: {
    title: 'О клиенте',
    contactLabel: 'Контакт',
    positionLabel: 'Должность',
    phoneLabel: 'Телефон',
    sizeLabel: 'Штат',
  },
  clientMonthReportTable: {
    licensesCountLabelText: 'Лицензий',
    tariffAmountLabelText: 'Тариф для клиента	',
    debitStatusLabelText: 'Оплата',
    startDateLabelText: 'Начало периода',
    endDateLabelText: 'Окончание',
    fallbackText: 'У клиента нет ни одного платежа',
    monthIncomeLabelText: 'Итого за месяц',
    periodIncomeLabelText(period) {
      const startDate = new Date(period.startDateISO);

      // К дате окончания добавляется день для включения дополнительного дня
      const endDate = addDays(new Date(period.endDateISO), 1);

      const diffText = formatDistanceStrict(startDate, endDate, {
        locale: ru,
        unit: 'day',
      });

      return `Итого за ${diffText}`;
    },
    partnerIncomeLabelText: 'Ваш доход',
    incomeValueText(amount, percent) {
      const amountText = sharedDictionaryRu.moneyAmountText(amount, 'USD');

      if (percent) {
        return `${amountText} (${percent}%)`;
      }

      return amountText;
    },
    titleText(calendarPeriod) {
      return sharedDictionaryRu.dates.monthOfYearDate(
        new Date(calendarPeriod.startDateISO)
      );
    },
    startDateText(calendarPeriod) {
      return sharedDictionaryRu.dates.fd1(
        new Date(calendarPeriod.startDateISO)
      );
    },
    endDateText(calendarPeriod) {
      return sharedDictionaryRu.dates.fd1(new Date(calendarPeriod.endDateISO));
    },
    debitStatusValueText(paid) {
      if (paid) {
        return 'Оплачено';
      }

      return 'Не оплачено';
    },
  },
  stackSummaryTable: {
    title: 'Программа',
    hostNameLabel: 'Адрес',
    managersCountLabel: 'Лицензий',
  },
  notesTitle: 'Заметки',
  notesInputPlaceholder:
    'Рекомендуем фиксировать любую информацию, которая поможет в работе с клиентом',
};
